import { ColumnRange } from '../interfaces/ColumnRange';
import { LayoutInterval } from '../interfaces/LayoutInterval';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/** Gets a value indicating whether the given intervals overlap. */
export function overlap(a: LayoutInterval | ColumnRange, b: LayoutInterval | ColumnRange): boolean {
    return a.start < b.end && a.end > b.start;
}

export function notOverlapOrAdjacentSurfaceItems(a: SurfaceItem, b: SurfaceItem): boolean {
    if (!a.model || !b.model) {
        return false;
    }
    if (b.model.Start < a.model.Start) {
        [a, b] = [b, a]; // swap them, a should precede b, based on the start time
    }
    return a.model.End < b.model.Start;
}

function isEventStandaloneInList(list: SurfaceItem[], eventIndex: number): boolean {
    for (let idx = 0; idx < list.length; idx++) {
        if (idx === eventIndex) {
            continue; // an event always overlaps with itself and hence skip this case
        }
        if (!notOverlapOrAdjacentSurfaceItems(list[eventIndex], list[idx])) {
            return false;
        }
    }
    return true;
}

export function eventWithoutAdjacentOverlap(eventId: string, inDayItems: SurfaceItem[]): boolean {
    // the previous function isEventStandaloneInList is definitely sufficient, this is just to take care of the case when the even might not be found in
    let findIndex = -1;
    for (let idx = 0; idx < inDayItems.length; idx++) {
        if (inDayItems[idx].model.ItemId.Id == eventId) {
            findIndex = idx;
            break;
        }
    }

    if (findIndex > -1) {
        return isEventStandaloneInList(inDayItems, findIndex);
    }
    return false;
}

/**
 * returns a boolean indicating whether two layout intervals are the same
 * @param a first layout interval to compare
 * @param b second layout interval to compare
 */
export function equals(a: LayoutInterval, b: LayoutInterval): boolean {
    return a.start == b.start && a.end == b.end;
}
